import { CreateProductFormSchemaType } from '../common';
import { FormLabel } from '../form-label';
import i18n from 'i18n';
import LOCALS from 'commons/locals';
import { Input } from 'antd';
import { Control, Controller } from 'react-hook-form';

const ProductRemark = ({
  control,
}: {
  control: Control<CreateProductFormSchemaType>;
}) => {
  return (
    <div className="flex gap-2">
      <FormLabel>{i18n.t(LOCALS.remark)}:</FormLabel>
      <Controller
        name="remark"
        control={control}
        render={({ field }) => (
          <Input.TextArea
            {...field}
            rows={4}
            placeholder={i18n.t(LOCALS.please_enter) || ''}
          />
        )}
      />
    </div>
  );
};

export default ProductRemark;
